import axios from "axios";
import toast from "react-hot-toast";
import { Base_URL } from "./utils/constant";

// Registered once at module load, not per-call - this used to be inside
// APICall() and re-registered a new interceptor on every single request,
// so by the end of a session a single response could trigger dozens of
// duplicate handlers (repeated toasts, repeated window.location.replace).
axios.interceptors.response.use(
  (response) => {
    if (response?.data?.authorization) {
      localStorage.setItem("access_token", response.data.authorization);
    }
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      sessionStorage.setItem("redirect", window.location.pathname);
      window.location.replace("/session-expired");
    }
    return error.response;
  }
);

export default async function APICall(
  Url,
  Method,
  Data,
  isFormData = false,
  timeoutOverride,
  silent
) {
  if (localStorage.getItem("token")) {
    const authToken = localStorage.getItem("token");
    axios.defaults.headers.common["Authorization"] = `Bearer ${authToken}`;
    axios.defaults.headers.common["Content-Type"] = isFormData
      ? "multipart/form-data"
      : `application/json`;
    axios.defaults.headers.common["cor"] = "no-cors";
  }
  // axios.defaults.withCredentials = true;

  let baseUrl = Base_URL;
  if (!baseUrl.endsWith("/")) {
    baseUrl = baseUrl + "/";
  }

  if (Url.startsWith("/")) {
    Url = Url.substring(1);
  }

  const response = await axios({
    method: Method,
    url: baseUrl + Url,
    data: Data,
    // timeout: timeoutOverride || process.env.REACT_APP_REQUEST_TIMEOUT,
  });

  if (response) {
    if (!response.status || response.status === 0) {
      if (!silent)
        toast.error("Please check you network connection and try again");
      return null;
    }

    if (response.status === 401 || response.statusText === "Unauthorized") {
      localStorage.removeItem("token");
      sessionStorage.setItem("sessionExpired", "true");
      return null;
    }

    if (response.status >= 400 && response.status < 500) {
      let message =
        "Sorry your request is invalid. please check your request and try again";
      if (response.data) {
        if (response.data.message) {
          message = `${response.data.message}`;
        } else {
          message = response.data;
        }
      }
      if (!silent) toast.error(message);
      return null;
    }
    if (response.status >= 500) {
      let message =
        "Sorry your request cannot be processed at this moment please try again later";
      if (response.data.message) {
        message = `${response.data.message}`;
      }
      if (!silent) toast.error(message);
      return null;
    }
  } else {
    if (!silent) {
      localStorage.clear();
      setTimeout(() => {
        localStorage.setItem("firstTime", true);
        window.location.href = "/";
      }, 2000);
      // toast.error(
      //   "Session Expired. Please login again to continue using the app"
      // );
    }
  }

  return !response
    ? null
    : response.data
    ? response.data
    : { status: "success" };
}
